import React from 'react';
import { DRAGGABLE_ELEMENTS, ROW_STRUCTURES } from '../utils/constants';

function LeftSidebar({ onDragStart, previewMode, onInsertTemplate, selectedCell }) {
  const handleDragStart = (e, item) => {
    onDragStart(item);
    e.dataTransfer.effectAllowed = 'move';
  };

  if (previewMode) {
    return null;
  }

  return (
    <div className="sidebar-left">
      <div className="sidebar-section">
        <h2>🏗️ Structures</h2>
        <div className="structures-list">
          {ROW_STRUCTURES.map((structure) => (
            <div
              key={structure.columns}
              className="structure-item"
              draggable
              onDragStart={(e) => handleDragStart(e, { type: 'structure', columns: structure.columns })}
            >
              <div className="structure-preview">
                {Array(structure.columns).fill(0).map((_, i) => (
                  <div key={i} className="structure-col"></div>
                ))}
              </div>
              <div className="structure-label">{structure.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h2>🧩 Éléments</h2>
        <div className="elements-grid">
          {DRAGGABLE_ELEMENTS.map((item) => (
            <div
              key={item.type}
              className="draggable-item"
              draggable
              onDragStart={(e) => handleDragStart(e, item)}
            >
              <div className="draggable-item-icon">{item.icon}</div>
              <div>{item.label}</div>
            </div>
          ))}
        </div>
      </div>

      {onInsertTemplate && (
        <div className="sidebar-section">
          <h2>🔧 Modèles</h2>
          <button
            className={`btn-insert-template ${!selectedCell ? 'disabled' : ''}`}
            onClick={selectedCell ? onInsertTemplate : undefined}
            disabled={!selectedCell}
            title={selectedCell ? "Insérer un modèle dans la cellule sélectionnée" : "Sélectionnez d'abord une cellule"}
          >
            <span className="btn-icon">🔧</span>
            <span>Insérer un Modèle</span>
          </button>
          <p className="sidebar-hint">
            {selectedCell
              ? `Cellule sélectionnée - Cliquez pour insérer un modèle`
              : `⚠️ Sélectionnez d'abord une cellule`}
          </p>
        </div>
      )}
    </div>
  );
}

export default LeftSidebar;
